import { SelectField, SelectFieldProps } from "matsuri-ui"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { css } from "@emotion/react"
import { requestSearchCommonAreaByName } from "../hooks/useCommonAreas"

export const CommonAreaSelectField = (
    props: Omit<SelectFieldProps, "loadOptions">
) => {
    const { token } = useAuth()
    return (
        <SelectField
            loadOptions={async ({ query, selectedOptions }) => {
                if (query === "") {
                    return selectedOptions
                }

                const { data } = await requestSearchCommonAreaByName(token, {
                    nameQuery: query,
                    pageSize: 20,
                    page: 0
                })
                if (data?.length === 0) {
                    return selectedOptions
                }

                return data?.map(d => ({
                    label: d.name,
                    value: d.id,
                    propertyAddress: d.propertyAddress
                }))
            }}
            renderOption={option => (
                <div>
                    <div>{option.label}</div>
                    {option.propertyAddress && (
                        <div
                            css={css`
                                margin-top: 2px;
                                font-size: 0.8rem;
                                color: #666;
                            `}
                        >
                            {option.propertyAddress}
                        </div>
                    )}
                </div>
            )}
            {...props}
        />
    )
}
